/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
  var old_models = [
    mp.marketing.trends.utils.IPHONE_11_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_11_PRO,
    mp.marketing.trends.utils.IPHONE_11,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];

  var release_models = [
	  mp.marketing.trends.utils.IPHONE_14,
    mp.marketing.trends.utils.IPHONE_14_PLUS,
    mp.marketing.trends.utils.IPHONE_14_PRO,
    mp.marketing.trends.utils.IPHONE_14_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_13,
    mp.marketing.trends.utils.IPHONE_13_MINI,
    mp.marketing.trends.utils.IPHONE_13_PRO,
    mp.marketing.trends.utils.IPHONE_13_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_12_MINI,
    mp.marketing.trends.utils.IPHONE_12_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_12,
    mp.marketing.trends.utils.IPHONE_12_PRO,
    mp.marketing.trends.utils.IPHONE_SE_2ND_GEN,
  ];

  var IPhoneModels = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models;
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    get_defaults() {
      return {
        date_range: new DateRange(new Date(2020, 8, 1), new Date()),
        report_unit: `week`,
      };
    },
    getDownloadName() {
      return ns.IPhoneModels.nice_name;
    },
  });

  Object.assign(IPhoneModels, {
    slug: `iphone_models`,
    nice_name: `iPhone models`,
    description: `How quickly will people put their new iPhones to use?`,
  });
  ns.IPhoneModels = IPhoneModels;

});

}.call(window));